import { Prototype } from "@xanadu/model";
import { DataCache } from "./data.cache";
import { DataService } from "../../service/data/data.service";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class PrototypeCache extends DataCache<Prototype> {

    constructor(
        dataService: DataService
    ) {
        super(Prototype, dataService);
    }
}
